<card name="Purchases table">
  <div card content>
    <smart-table [headers]="headers" [source]="source">
      <ng-template smartTableColumn="id" let-item>
        <td>
          {{ item.id }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="userID" let-item>
        <td>
          {{ item.userID }}
        </td>
      </ng-template>


      <ng-template smartTableColumn="price" let-item>
        <td>
          {{ item.price | numeral: 'currency' }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="currency" let-item>
        <td>
          {{ item.currency }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="market" let-item>
        <td>
          <div class="d-flex align-items-center">
            <ng-container [ngSwitch]="item.market">
              <icon-apple class="text-muted mb-1 mr-2" [style.width.px]="12" *ngSwitchCase="'IOS'"></icon-apple>
              <icon-android class="text-muted mr-2" [style.width.px]="12" *ngSwitchCase="'Android'"></icon-android>
            </ng-container>
            {{ item.market }}
          </div>
        </td>
      </ng-template>

      <ng-template smartTableColumn="productID" let-item>
        <td>
          {{ item.productID }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="type" let-item>
        <td>
          {{ item.type }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="expiredAt" let-item>
        <td>
          {{ item.expiredAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="receipt" let-item>
        <td>
          <a routerLink="/">№{{ item.receipt }}</a>
        </td>
      </ng-template>

      <ng-template smartTableColumn="force" let-item>
        <td>
          <badge-exist existText="Force" [item]="item.force"></badge-exist>
        </td>
      </ng-template>

      <ng-template smartTableColumn="subject" let-item>
        <td>
          {{ item.subject }}
        </td>
      </ng-template>
    </smart-table>
  </div>
</card>
